function clearDatePickerDesktop(pickerId, pickerFromId, pickerToId) {
    $('#' + pickerFromId + ", " +
        '#' + pickerToId + ", " +
        '#' + pickerId + '-container input, ' +
        '#' + pickerId + '-container .datepicker-content, ' +
        '#' + pickerId + '-container .datepicker-duration'
    )
        .val('').text('').html('');
}

function getDatePickerDesktop(pickerId, pickerFromId, pickerToId, dateFrom, dateTo, calendar, range, onpicker) {
    var dfrom, dto, dfromx, dtox;
    if (!range) {
        dfrom = $('#' + pickerFromId).val();
        dfromx = calendar.fromJD($.calendars.instance().parseDate('yyyy-mm-dd', dfrom).toJD()); //.replace(/-/g, '/');
        return [dfromx];
    } else {
        try {
            dfrom = $('#' + pickerFromId).val();
            dfromx = calendar.fromJD($.calendars.instance().parseDate('yyyy-mm-dd', dfrom).toJD()); //.replace(/-/g, '/');
        } catch (e) { }
        try {
            dto = $('#' + pickerToId).val();
            dtox = calendar.fromJD($.calendars.instance().parseDate('yyyy-mm-dd', dto).toJD());
        } catch (e) {
        }
        return [dfromx, dtox];
    }
}
function setDatePickerDesktop(pickerId, pickerFromId, pickerToId, dateFrom, dateTo, calendar, range) {
    try {       
        var root = $('#' + pickerId + '-container');
        var from, to;
        var from_t, to_t;
        var comma = (calendar.name.toLowerCase() == 'persian') ? "،" : ",";        
        if (!range) {
            from = `${calendar.formatDate('DD', dateFrom)}${comma} <b>${calendar.formatDate('d', dateFrom)}</b> ${calendar.formatDate('MMM', dateFrom)}`;
            from_t = calendar.formatDate('DD d MMM yyyy', dateFrom);
            root.find('.datepicker-from-content').html(localNumber(from, calendar));

            root.find('.m-datepicker__duration').html(localNumber(from_t, calendar));
            root.find('.m-datepicker__selected-return').addClass('d-none');
            if (calendar.local.isRTL) {
                root.find('.datepicker-content').addClass("isRTL");
                root.find('.datepicker-content').removeClass("isLTR");
            }
            else {
                root.find('.datepicker-content').addClass("isLTR");
                root.find('.datepicker-content').removeClass("isRTL");
            }

        }
        else {
            from = `${calendar.formatDate('DD', dateFrom)}${comma} <b>${calendar.formatDate('d', dateFrom)}</b> ${calendar.formatDate('MMM', dateFrom)}`;
            from_t = calendar.formatDate('DD d MMM yyyy', dateFrom);
            to = `${calendar.formatDate('DD', dateTo)}${comma} <b>${calendar.formatDate('d', dateTo)}</b> ${calendar.formatDate('MMM', dateTo)}`;
            to_t = calendar.formatDate('DD d MMM yyyy', dateTo);
            root.find('.datepicker-from-content').html(localNumber(from, calendar));
            root.find('.datepicker-to-content').html(localNumber(to, calendar));

            root.find('.m-datepicker__duration').html(localNumber(from_t + " - " + to_t, calendar));
            root.find('.m-datepicker__selected-return').removeClass('d-none');
            if (calendar.local.isRTL) {
                root.find('.datepicker-content').addClass("isRTL");
                root.find('.datepicker-content').removeClass("isLTR");
            }
            else {
                root.find('.datepicker-content').addClass("isLTR");
                root.find('.datepicker-content').removeClass("isRTL");
            }

        }

        if (!xisnull(dateFrom)) {
            var dfrom = $.calendars.instance().fromJD(dateFrom.toJD()).toString();
            $('#' + pickerFromId).val(dfrom).data('value', dfrom);
        }
        if (!xisnull(dateTo)) {
            var dto = $.calendars.instance().fromJD(dateTo.toJD()).toString();
            $('#' + pickerToId).val(dto).data('value', dto);
        }

    }
    catch (e) {

    }
}
function changeDatePicker(elementId, toggle) {
    switch (toggle) {
        case 1:
            $('#' + elementId + '-container div[data-trip-way="return"]').removeClass('d-none');
            $('#' + elementId).calendarsPicker('option', { rangeSelect: true });
            break;
        case 2:
            $('#' + elementId + '-container div[data-trip-way="return"]').addClass('d-none');
            $('#' + elementId).calendarsPicker('option', { rangeSelect: false });
            break;
    }
}
function initDatePickerDesktop(model) {

    var renderer = {

        "default":
        {
            picker: '<div class="m-datepicker calendars datepick ' + model.pickerId + '-datepick"><div class="m-datepicker__nav">{link:prev}{link:next}</div><div class="m-datepicker__months">{months}</div><div class="datepicker-fromto d-none"><div class="datepicker-from"><div class="datepicker-from-label">رفت</div><div class="datepicker-from-content"></div></div><div class="datepicker-to"><div class="datepicker-to-label">برگشت</div><div class="datepicker-to-content"></div></div></div>{popup:start}<div class="row oneWay-price d-none"><div class="col-md-12 d-flex pill-pos m-b-sm pill-margin"><div class="price-pill-style price-pill-cheap"><span class="price-pill">ارزان</span></div><div class="price-pill-style price-pill-moderate"><span class="price-pill">متوسط</span></div><div class="price-pill-style price-pill-expensive"><span class="price-pill">گران</span></div></div></div><div class="m-datepicker__footer"><div class="m-datepicker__submit">{link:submit}</div><div class="m-datepicker__duration datepicker-duration"></div><div class="m-datepicker__swtich">{link:switchCalendar}</div></div>{popup:end}</div>',
            monthRow: '<div class="calendars-month-row">{months}</div>',
            month: '<div class="m-datepicker__month"><div class="m-datepicker__month-header">{monthHeader}</div>' +
                '<table><thead>{weekHeader}</thead><tbody>{weeks}</tbody></table></div>',
            weekHeader: '<tr class="m-datepicker__week-header">{days}</tr>',
            dayHeader: '<th class="m-datepicker__day-header">{day}</th>',
            week: '<tr class="m-datepicker__weeek">{days}</tr>',
            day: '<td class="m-datepicker__day">{day}</td>',
            monthSelector: '.m-datepicker__month',
            daySelector: 'td',
            rtlClass: 'm-datepicker__rtl',
            multiClass: 'm-datepicker__multi',
            defaultClass: '',
            selectedClass: 'm-datepicker__selected',
            highlightedClass: 'm-datepicker__highlight',
            todayClass: 'm-datepicker__today',
            otherMonthClass: 'm-datepicker__other-month',
            weekendClass: 'm-datepicker__weekend',
            commandClass: 'm-datepicker__cmd',
            commandButtonClass: '',
            commandLinkClass: '',
            disabledClass: 'm-datepicker__disabled',
            scrollContainerSelector: 'm-datepicker__month-list',
            daysRangeHoverClass: 'm-datepicker__range-hover',
            daysRangeClass: 'm-datepicker__range'
        },
        "custom":
        {
            picker: '<div class="m-datepicker calendars datepick ' + model.pickerId + '-datepick"><div class="m-datepicker__nav">{link:prev}{link:next}</div><div class="m-datepicker__months">{months}</div><div class="datepicker-fromto d-none"><div class="datepicker-from"><div class="datepicker-from-label">رفت</div><div class="datepicker-from-content"></div></div><div class="datepicker-to"><div class="datepicker-to-label">برگشت</div><div class="datepicker-to-content"></div></div></div>{popup:start}<div class="m-datepicker__footer"><div class="m-datepicker__submit">{link:submit}</div><div class="m-datepicker__duration datepicker-duration"></div><div class="m-datepicker__swtich">{link:switchCalendar}</div></div>{popup:end}</div>',
            monthRow: '<div class="calendars-month-row">{months}</div>',
            month: '<div class="m-datepicker__month"><div class="m-datepicker__month-header">{monthHeader}</div>' +
                '<table><thead>{weekHeader}</thead><tbody>{weeks}</tbody></table></div>',
            weekHeader: '<tr class="m-datepicker__week-header">{days}</tr>',
            dayHeader: '<th class="m-datepicker__day-header">{day}</th>',
            week: '<tr class="m-datepicker__weeek">{days}</tr>',
            day: '<td class="m-datepicker__day">{day}</td>',
            monthSelector: '.m-datepicker__month',
            daySelector: 'td',
            rtlClass: 'm-datepicker__rtl',
            multiClass: 'm-datepicker__multi',
            defaultClass: '',
            selectedClass: 'm-datepicker__selected',
            highlightedClass: 'm-datepicker__highlight',
            todayClass: 'm-datepicker__today',
            otherMonthClass: 'm-datepicker__other-month',
            weekendClass: 'm-datepicker__weekend',
            commandClass: 'm-datepicker__cmd',
            commandButtonClass: '',
            commandLinkClass: '',
            disabledClass: 'm-datepicker__disabled',
            scrollContainerSelector: 'm-datepicker__month-list',
            daysRangeHoverClass: 'm-datepicker__range-hover',
            daysRangeClass: 'm-datepicker__range'

        }
    };

    if (model.renderStyle === "linear") {
        InitDatePickerLinear(model);
        $('#' + model.pickerId).addClass("border__blue");

    }

    else {
        $('#' + model.pickerId).calendarsPicker(
            {
                storageKey: model.storageKey,
                rangeSelect: model.range,
                rangeMinOffset: (model.rangeMinOffset != NaN && model.rangeMinOffset != "") ? parseInt(model.rangeMinOffset) : undefined,
                rangeMaxOffset: (model.rangeMaxOffset != NaN && model.rangeMaxOffset != "") ? parseInt(model.rangeMaxOffset) : undefined,
                monthsToShow: (model.dual ? [2, 1] : 1),
                monthsToStep: model.dual ? 2 : 1,
                minDate: notEmpty(model.minDate) ? (model.minDate === '0' ? parseInt('0') : model.minDate) : 0,
                maxDate: notEmpty(model.maxDate) ? (model.maxDate === '0' ? parseInt('0') : model.maxDate) : '+1y',
                showOtherMonths: false,
                showTrigger: '<div class="' + model.pickerId + '-trigger m-datepicker__mask"></div>',
                changeMonth: model.monthChanger,
                calendar: model.calendar == 'persian' ?
                    $.calendars.instance('persian', 'fa') :
                    $.calendars.instance('gregorian', 'en'),
                manualClose: true,
                clickOutsideClose: true,
                showAnim: 'show',
                prevText: '<span class="icon-0036"></span>',
                nextText: '<span class="icon-0096-1"></span>',
                popupContainer: '#' + model.pickerId + '-container',
                localNumbers: true,
                onSelectClick: function (inst, el) {
                    var range = inst.options.rangeSelect;
                    var dates = el.calendarsPicker('getDate');
                    try {
                        if (model.dual)
                            showMonth(inst, el, dates);

                        setDatePickerDesktop(
                            model.pickerId,
                            model.pickerFromId,
                            model.pickerToId,
                            dates[0],
                            dates[1],
                            inst.options.calendar,
                            inst.options.rangeSelect
                        );
                        if (range) {
                            $(".middle-selected").last().addClass("middle-last");
                            $(".middle-selected").first().addClass("middle-first");
                        }
                    } catch (e) {
                    }
                },
                onSelect: function (inst, el, dates) {

                    try {
                        var xdates = [
                            (dates[0] != undefined) ? inst.options.calendar.formatDate('yyyy-mm-dd', dates[0]) : undefined,
                            (dates[1] != undefined) ? inst.options.calendar.formatDate('yyyy-mm-dd', dates[1]) : undefined
                        ];
                        storagehandler("save", inst.options.storageKey, { range: inst.options.rangeSelect, dates: xdates, isShamsi: inst.options.calendar.name.toLowerCase() == "persian" });

                        setDatePickerDesktop(
                            model.pickerId,
                            model.pickerFromId,
                            model.pickerToId,
                            dates[0],
                            dates[1],
                            calendar,
                            range,
                            false
                        );
                        
                    } catch (e) {
                    }
                },
                onDate: function (inst, elem, date) {
                    var isShamsi = (inst.options.calendar.name.toLowerCase() == 'persian');
                    var gregorianDate = isShamsi ? convertDateToGregorian(date) : date;
                    var elementID = 'date-' + gregorianDate._year.toString().padStart(4, '0') + '-' + gregorianDate._month.toString().padStart(2, '0') + '-' + gregorianDate._day.toString().padStart(2, '0') ;
                    var weekend = IsWeekend(date);
                    return {
                        content: (!inst.options.rangeSelect) ?
                            `<span id='${elementID}'>${localNumber(date.day(), inst.options.calendar)}</span><i class='day-price icon-0034'></i>` :
                            `<span>${localNumber(date.day(), inst.options.calendar)}</span>`,
                        dateClass: weekend ? 'm-datepicker__weekend' : ''
                    };
                },
                onClear: function (inst, el) {
                    clearDatePickerDesktop(model.pickerId);
                },
                onBeforeShow: function (inst, el) {
                    $('#' + model.pickerId + "-container").addClass("border__blue");
                },
                onClose: function (inst, el) {
                    $('#' + model.pickerId + "-container").removeClass("border__blue");
                },
                onAfterShow: function (inst, el) {
                    var calendar = inst.options.calendar;
                    var range = inst.options.rangeSelect;
                    var dates = getDatePickerDesktop(null, model.pickerFromId, model.pickerToId, null, null, calendar, range);
                    var flag = (calendar.name.toLowerCase() == 'persian');
                    el.calendarsPicker('setDate', dates);

                    var isFlightSelectedTab = $("#flight-tab").hasClass("active") || ($("#flight-tab").length == 0 && $("#FlightSearchForm").length != 0);
                    if ((!range && isFlightSelectedTab))//only show in one-way flight
                        inst.div.find(".oneWay-price").removeClass("d-none");
                    else
                        inst.div.find(".oneWay-price").addClass("d-none");
                    if (!flag) {
                        inst.div.find(".price-pill-expensive span").text("Expensive");
                        inst.div.find(".price-pill-moderate span").text("Moderate");
                        inst.div.find(".price-pill-cheap span").text("Cheap");

                    }
                    else {
                        inst.div.find(".price-pill-expensive span").text("گران");
                        inst.div.find(".price-pill-moderate span").text("متوسط");
                        inst.div.find(".price-pill-cheap span").text("ارزان");
                    }
                    //show month and year related to selected date --------------------------------------
                    showMonth(inst, el, inst.options.selectedDates);
                    if (range) {

                        $(".middle-selected").last().addClass("middle-last");
                        $(".middle-selected").first().addClass("middle-first");

                    }
                },
                onBeforeSwitchCalendar(inst) {
                    $(".middle-selected").last().addClass("middle-last");
                    $(".middle-selected").first().addClass("middle-first");
                },
                onAfterSwitchCalendar(inst) {
                    $(".middle-selected").last().addClass("middle-last");
                    $(".middle-selected").first().addClass("middle-first");
                },
                onCreate: function (inst, el) {
                    try {
                       
                        //reset price in date picker (just for one way flight) -----------------------------
                        if (!inst.options.rangeSelect && $(el).prop("id") == "FlightSearchSegments" && !inst.loadDone) {
                            if (!isTrainDatepicker) {
                                loadPrices(model.source, model.destination);
                            }
                        }

                        //set value of date picker ---------------------------------------------------------
                        setDatePickerDesktop(
                            model.pickerId,
                            model.pickerFromId,
                            model.pickerToId,
                            inst.options.selectedDates[0],
                            inst.options.selectedDates[1],
                            inst.options.calendar,
                            inst.options.rangeSelect);



                    } catch (e) {
                    }
                },
                renderer: renderer[model.pickerStyle]
            });
    }
}
function showMonth(inst, el, selectedDates) {

    var currentMonthIsEven = inst.options.calendar.today().month() % 2 == 0;
    if (inst.options.rangeSelect) {
        //two-way 
        //show month when selectd start or stop date is even month like shahrivar
        var month = selectedDates[inst.completeSelection && !inst.startSelectionChanged ? 1 : 0].month();
        var year = selectedDates[inst.completeSelection && !inst.startSelectionChanged ? 1 : 0].year();
        if (month % 2 == (currentMonthIsEven ? 1 : 0))
            el.calendarsPicker('showMonth', year, (month % 2 == (currentMonthIsEven ? 1 : 0) && month != 1) ? month - 1 : month);
    }
    else {
        //one-way
        var year = inst.options.calendar.today().year();
        var month = inst.options.calendar.today().month();
        month = selectedDates[0].month();
        year = selectedDates[0].year();
        el.calendarsPicker('showMonth', year, (month % 2 == (currentMonthIsEven ? 1 : 0) && month != 1) ? month - 1 : month);
    }
}
